export default __webpack_public_path__ + "static/size-guide-e8f0a355272d1deef0b22913473539c5.jpg";